import React, { Dispatch, FC, MutableRefObject, SetStateAction } from "react";
import { observer } from "mobx-react-lite";
import styles from "../../index.module.scss";
import { langStore } from "@noli/business";
import config from "@/config";
import { postOpusPublish } from "@/pages/Gallery/api";
import { PublishForm } from "@/components/bussiness/PublishForm";
import { PostWorkRequestData } from "@/modules/editor/request";
import { galleryLangRecords } from "@/pages/Gallery/lang";
import { Toast } from "@/components/Toast";
import { ReFreshType } from "..";

interface EditingWorksProps {
  defaultValues: any;
  opusId?: number;
  onPageState: Dispatch<SetStateAction<1 | 2>>;
  onRefresh?: (type: ReFreshType) => void;
  onClose?: () => void;
  onError?: (e: any) => void;
}

const EditingWorks: FC<EditingWorksProps> = (props) => {
  const lang = langStore.tgt;
  const { defaultValues, opusId, onRefresh, onClose, onPageState, onError } = props;
  const [loading, setLoading] = React.useState(false);
  const handleConfirm = async (serverData: PostWorkRequestData) => {
    setLoading(true);
    try {
      await postOpusPublish({
        ...serverData,
        opus_id: opusId as number,
      });
      onRefresh?.(1);
      onClose?.();
      Toast({
        status: "success",
        position: "top",
        description: galleryLangRecords[lang]["SubmittedPublishing"],
      });
    } catch (e) {
      onError?.(e);
    } finally {
      setLoading(false);
    }
  };
  const handleClose = () => {
    onPageState(1);
  };
  return (
    <div style={{ display: "flex", flexFlow: "column" }}>
      <div className={styles.topWrapper}>
        <img
          src={`${config.buildCdnBaseUrl}assets/creator/arrow-left-editing.png`}
          alt=""
          onClick={() => {
            handleClose();
          }}
        />
        {galleryLangRecords[lang]["Editing-Works"]}
      </div>
      <PublishForm
        footerClassName="publishFormFooter"
        bodyClassName="publishFormBody"
        className={styles.publishForm}
        onConfirm={handleConfirm}
        loading={loading}
        onCancel={handleClose}
        defaultValues={defaultValues}
        isEdit={true}
      />
    </div>
  );
};
export default observer(EditingWorks);
